(() => {
  const config = JSON.parse(document.getElementById('pf-context')?.textContent || '{}');
  const root = config.root?.endsWith('/') ? config.root : `${config.root || ''}/`;
  const valid = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,250}$/.test(value);
  const dialog = document.getElementById('pf-demand-dialog');
  let feed, loading, trigger;
  const pending = new Set();
  const announce = message => { const status = document.getElementById('pf-status'); if (status) status.textContent = message; };
  async function request(body) {
    const response = await fetch(`${root}apps/favourites?feature=demand`, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: body ? { 'Content-Type': 'application/json' } : {},
      body: body ? JSON.stringify({ ...body, csrf: feed?.csrf }) : undefined,
      signal: AbortSignal.timeout(20000),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || 'Demand could not be saved. Please try again.');
    return data;
  }
  function sync() { document.querySelectorAll('pf-product-demand').forEach(el => el.render()); }
  async function refresh() {
    if (loading) return loading;
    loading = (async () => {
      try { const result = await request(); if (!Array.isArray(result.products)) throw new Error('Demand counts are unavailable.'); feed = result; sync(); window.dispatchEvent(new CustomEvent('pf:demand', { detail: result.products })); return true; }
      catch (error) { document.querySelectorAll('pf-product-demand').forEach(el => el.showError(error.message)); return false; }
      finally { loading = null; }
    })();
    return loading;
  }
  async function vote(handle) {
    if (pending.has(handle)) return false;
    pending.add(handle); sync();
    try {
      if (!feed?.csrf && !await refresh()) return false;
      const result = await request({ handle });
      const item = feed.products.find(p => p.productId === result.productId);
      if (item) Object.assign(item, result); else feed.products.push({ ...result, handle });
      announce('Your interest is counted. This is not a reservation or order.');
      return true;
    } catch (error) {
      document.querySelectorAll('pf-product-demand').forEach(el => { if (el.dataset.handle === handle) el.showError(error.message); });
      announce(error.message); return false;
    } finally { pending.delete(handle); sync(); }
  }
  function login(handle, button) {
    trigger = button;
    const destination = new URL(location.href); destination.searchParams.set('want_product', handle);
    const link = dialog.querySelector('[data-demand-signin]'), url = new URL(config.login, location.origin);
    url.searchParams.set('return_to', destination.pathname + destination.search + destination.hash);
    link.href = url.href;
    link.onclick = () => { try { sessionStorage.setItem('pf-pending-demand', handle); } catch {} };
    dialog.showModal();
  }
  dialog?.querySelector('[data-demand-dismiss]').addEventListener('click', () => dialog.close());
  dialog?.addEventListener('close', () => trigger?.focus());
  if (!customElements.get('pf-product-demand')) customElements.define('pf-product-demand', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      this.addEventListener('click', async event => {
        const button = event.target.closest('.pf-want-button'); if (!button || !valid(this.dataset.handle)) return;
        if (!config.customer) { login(this.dataset.handle, button); return; }
        this.querySelector('.pf-demand-error').textContent = '';
        if (!feed && !await refresh()) return;
        await vote(this.dataset.handle);
      }, { signal: this.abort.signal });
      this.render();
    }
    disconnectedCallback() { this.abort?.abort(); }
    showError(message) { this.querySelector('.pf-demand-error').textContent = message; const button = this.querySelector('button'); if (button) button.disabled = false; }
    render() {
      const item = feed?.products.find(p => p.productId === this.dataset.productId);
      const button = this.querySelector('.pf-want-button');
      if (button && feed) {
        button.disabled = pending.has(this.dataset.handle) || !!item?.voted;
        this.querySelector('[data-want-label]').textContent = item?.voted ? 'Counted' : pending.has(this.dataset.handle) ? 'Saving…' : 'I Want This';
        const count = this.querySelector('[data-want-count]'); count.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { notation: 'compact', maximumFractionDigits: 1 }).format(item?.count || 0); count.setAttribute('aria-label', `${item?.count || 0} interested shoppers`);
      }
      this.querySelector('.pf-restock-label').hidden = !(this.dataset.available === 'true' && item?.backInStock);
    }
  });
  window.addEventListener('focus', () => { if (!pending.size) refresh(); });
  (async () => {
    if (!await refresh()) return;
    if (!config.customer) return;
    const page = new URL(location.href);let handle = page.searchParams.get('want_product');
    try { handle ||= sessionStorage.getItem('pf-pending-demand'); } catch {}
    if (valid(handle) && await vote(handle)) {
      try { sessionStorage.removeItem('pf-pending-demand'); } catch {}
      page.searchParams.delete('want_product');history.replaceState(history.state, '', page.pathname + page.search + page.hash);
    }
  })();
})();
